import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteComponent } from './autocomplete.component';
import { PipesModule } from './pipes/pipes.module';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [AutoCompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule
  ],
  exports: [
    AutoCompleteComponent
  ]
})
export class AutoCompleteModule{ }
